import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Layout, Button, message, Form, Input } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import LoadingOverlay from "react-loading-overlay-ts";

import { getMemberDigitalApi } from "../../services/Member/MemberApis";
import { authenticateMemberApi } from "../../services/Member/MemberApis";

const { Content } = Layout;

const MemberAuthenticationPage: React.FC = () => {
  const navigate = useNavigate();
  const { memberId }: any = useParams();

  const [isActive, setActive] = useState(true);
  const [idNumber, setIdNumber] = useState("");
  const [member, setMember] = useState<any>({});

  useEffect(() => {
    getMemberDigitalApi(String(memberId))
      .then((res: any) => {
        console.log(res.data)
        setMember(res.data);
        setActive(false);
      })
      .catch((err: any) => {
        console.log(err);
      });
  }, [memberId]);

  const handleAuthenticate = async () => {
    if (idNumber) {
      authenticateMemberApi(memberId, { IdNumber: idNumber })
        .then((res) => {
          if (res.success) {
            navigate(`/members/otp/${memberId}`);
            setActive(false);
          } else {
            message.error("Incorrect ID Number, Please try again.");
          }
        })
        .catch((err) => {
          console.log(err);
          setActive(false);
        });
    } else {
      message.warning("Please provide an ID Number before saving.");
    }
  };

  return (
<LoadingOverlay active={isActive} spinner={<LoadingOutlined />}>
  <Layout style={{ minHeight: "100vh" }}>
    <Layout className="site-layout">
      <Content
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          background: "#fff",
          padding: "24px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            width: "100%",
            maxWidth: "500px", // Limits the width on large screens
            padding: "16px",
            boxSizing: "border-box",
          }}
        >
          {member.Group?.CompanyLogo && (
            <img
              src={member.Group.CompanyLogo}
              alt="Group Logo"
              style={{
                marginBottom: "24px",
                maxWidth: "100%",
                height: "auto",
              }}
            />
          )}
          <h3
            style={{
              marginBottom: "24px",
              padding: "0 16px",
              fontSize: "1.1em",
              lineHeight: "1.5",
            }}
          >
            Thank you for choosing {member?.Group?.GroupName} for your
            funeral policy. Please verify your identity to continue and
            complete your application.
          </h3>
          <Form.Item
            name="IdNumber"
            rules={[
              { required: true, message: "Please input your ID Number" },
            ]}
            style={{ marginBottom: "16px" }}
          >
            <Input
              onChange={(e) => setIdNumber(e.target.value)}
              size="large"
              placeholder="ID Number"
            />
          </Form.Item>
          <Button
            type="primary"
            size="large"
            onClick={handleAuthenticate}
            style={{ width: "100%", marginTop: "16px" }}
          >
            Submit
          </Button>
        </div>
      </Content>
    </Layout>
  </Layout>
</LoadingOverlay>

  );
};

export default MemberAuthenticationPage;
